var exports = {
  "i": "message__-KCGuF",
};

module.exports = exports;
